// ==============================|| CENTRALIZED METALLIC COLOR PALETTE ||============================== //

export const metallicPalette = {
  primary: {
    lighter: '#F1F5F9',   // Silky Platinum Slate
    100: '#E2E8F0',
    200: '#CBD5E1',
    light: '#64748B',     // Slate Light Accent
    400: '#546E7A',
    main: '#475569',      // Cool Metallic Slate (Login Page Theme)
    dark: '#334155',      // Deep Steel
    700: '#273444',
    darker: '#1E293B',    // Steel Charcoal
    900: '#0F172A',
    contrastText: '#FFFFFF'
  },
  accent: {
    roseGold: '#B76E79',   // Metallic Rose Gold Highlight
    champagne: '#E5D3B3',  // Metallic Champagne Highlight
    copper: '#C48B71',
    steelBlue: '#384B60'
  },
  grey: {
    0: '#FFFFFF',
    1: '#F8FAFC',        // Cool Off-White Canvas Background
    2: '#F1F5F9',
    3: '#E2E8F0',
    4: '#CBD5E1',
    5: '#94A3B8',
    6: '#64748B',
    7: '#475569',
    8: '#334155',
    9: '#1E293B',
    10: '#0F172A'
  }
};

// Backward-compatible alias for plumPalette references
export const plumPalette = metallicPalette;

export default metallicPalette;
